<template>
  <div class="tem-good-list">
    <!-- 商品列表 -->
    <div class="good-list" v-if="goodsList.length">
      <el-row :gutter="20">
        <el-col
          style="width: 20%"
          v-for="(item, index) in goodsList"
          :key="index"
          @click.native="goodDetail(item)"
        >
          <div class="goods-show-info">
            <div class="good-info-img">
            <img
              :src="item.fileUrl ? item.fileUrl : 'static/img/bitmap.png'"
              alt=""
              class="good-img fit-contain"
            />
          </div>
          <div class="good-info">
            <div class="good-info-name overell" :title="item.spuName">
              {{ item.spuName }}
            </div>
            <div class="good-info-price overell">
              <div>
                <!-- <span v-if="item.commodityType != '10'" class="good-info-price-activity">
                  ￥{{(item.activityPrice && item.activityPrice)}}
                </span> -->
                <div v-show="false">
                  {{ $route.name }}
                  <br />
                  {{ item.commoditySpuVo && item.commoditySpuVo.commodityType }}
                  <br />
                  {{
                    item.commoditySpuVo &&
                    item.commoditySpuVo.isSellingPriceExpire
                  }}
                </div>
                <good-price
                  v-show="
                    item.commoditySpuVo &&
                    item.commoditySpuVo.commodityType &&
                    item.commoditySpuVo.commodityType.indexOf('非标') === -1 &&
                    !item.commoditySpuVo.isSellingPriceExpire
                  "
                  :price="Number(item.activityPrice) || 0"
                ></good-price>
                <span
                  v-show="
                    (item.commoditySpuVo &&
                      item.commoditySpuVo.commodityType &&
                      item.commoditySpuVo.commodityType.indexOf('非标') > -1) ||
                    item.commoditySpuVo.isSellingPriceExpire
                  "
                  class="good-info-price-activity"
                  >{{ $t("home.rfq") }}</span
                >
                <span v-show="$route.name === 'actuvutyGoodList'">
                  <span
                    v-if="item.tagPrice !== '' && item.tagPrice !== null"
                    class="good-info-price-original"
                    >￥{{ item.tagPrice }}</span
                  >
                  <span v-else class="good-info-price-original"
                    >￥{{ item.sellingPrice }}</span
                  >
                </span>
              </div>
            </div>
            <div
              style="margin-bottom: 3px"
              v-if="item.commoditySpuVo && item.commoditySpuVo.tagNameList && item.commoditySpuVo.tagNameList.length"
            >
              <el-tag
                v-for="(itm, index) in item.commoditySpuVo.tagNameList"
                :key="index"
                size="mini"
                style="margin-right: 3px"
                type="danger"
                effect="dark"
              >
                {{ itm }}
              </el-tag>
            </div>
            <div class="good-attribute overell">
              {{ $t("common.brand") }}：&nbsp;{{ item.brandName }}
            </div>
            <div
              class="good-attribute overell"
              v-show="$route.name === 'actuvutyGoodList'"
            >
              {{ $t("common.model") }}：&nbsp;{{ item.model }}
            </div>
          </div>
          </div>
        </el-col>
      </el-row>
      <el-divider content-position="center">{{
        $t("product.bottomLine")
      }}</el-divider>
    </div>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price'
// import {goodDetailBuryingpoint, hotCategoriesDetail} from '@/utils/eventTracking'
import { openOther } from '@/utils/index'
export default {
  data () {
    return {}
  },
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pagerCount: {
      type: Number,
      default: 5
    },
    total: {
      type: Number,
      default: 0
    }
  },
  components: {
    GoodPrice
  },
  filters: {
    getBrand (arr) {
      let result = ''
      if (arr && arr.length) {
        let index = arr.findIndex((item) => {
          return item.branded === true
        })
        if (index > -1) {
          result = arr[index].productAttributeValues[0]
        }
      }
      return result
    },
    getModel (arr) {
      let result = ''
      if (arr && arr.length) {
        let index = arr.findIndex((item) => {
          return item.productAttribute === '型号'
        })
        if (index > -1) {
          result = arr[index].productAttributeValues[0]
        }
      }
      return result
    }
  },
  methods: {
    // 进入商品详情页
    goodDetail (good) {
      if (good) {
        openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId || ''}`)
      }
    },
    handleSizeChange (val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },
    goodDetailBuryingpoint (keyWord) {
      let params = {
        keyWord: keyWord
      }
      this.$request
        .post(`/buryingpoint/buryingpoint/commodityChoice`, params)
        .then((data) => {
          if (data.code === 0) {
            this.categoryTree = data.data || []
          }
        })
        .catch(() => {})
    },
    hotCategoriesDetail (keyWord) {
      let params = {
        keyWord: keyWord
      }
      this.$request
        .post(`/buryingpoint/buryingpoint/hotCategoriesDetail`, params)
        .then((data) => {
          if (data.code === 0) {
            this.categoryTree = data.data || []
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">
.tem-good-list {
  .good-list {
    background: #fff;
    .el-row {
      display: flex;
      flex-wrap: wrap;
      .el-col {
        .goods-show-info {
          height: calc(100% - 10px);
        }
      }
    }
    .goods-show-info {
      margin-bottom: 10px;
      height: 330px;
      cursor: pointer;
      -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
      -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
      box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;

      &:hover {
        -webkit-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
        -moz-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
        box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      }
      .good-info-img {
        background: #fff;
        width: 100%;
        height: 200px;
        .good-img {
          width: 100%;
          height: 200px;
        }
      }
      .good-info {
        background: #fff;
        margin-top: 3px;
        padding: 20px 10px;
        .good-info-name {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0.2px;
          line-height: 20px;
        }
        .good-info-price {
          font-size: 18px;
          color: #e33135;
          letter-spacing: 0.2px;
          line-height: 30px;
          font-weight: bold;
          .good-info-price-activity {
          }
          /deep/ .price {
            margin-top: 10px;
            color: #e64c3a;
            font-weight: bold;
            font-size: 18px;
            display: inline-block;
            .price-int {
              // font-size: 18px;
            }
            .price-point {
              // font-size: 10px;
            }
          }
          .good-info-price-original {
            color: #ccc;
            font-size: 12px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>
<style>
.tem-good-list .el-divider__text {
  background: #f9f9f9 !important;
}
</style>
